import ExpenseListPage from '@/components/expenses/ExpenseListPage';

const Expenses = () => {
  return <ExpenseListPage />;
};

export default Expenses;
